module.exports = __webpack_public_path__ + "static/media/W5390484_35.a2aba2ef.jpg";